import { useEffect, useState } from "react";
import useQuotes from "../hooks/useQuotes";
import useWebData from "../hooks/useWebData";
import useReservation from "../hooks/useReservationData";
import usePleaseWait from "../hooks/usePleaseWait";
import { post_quote, sendQuoteEmailAPI } from "../services/quotes";
import { tenantId } from "../config/api";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const QuotePopup = () => {
    const { customerData,
        customerId,
        vehicleClassId,
        branchId,
        pickupLocationId,
        returnLocationId,
        pickupDate,
        pickupTime,
        returnDate,
        returnTime,
        reservation
    }: any = useReservation();
    const { webData }: any = useWebData();
    const { open, setOpen, quoteFormType }: any = useQuotes();
    const { setPleasWaitPopup }: any = usePleaseWait();
    const [tag, setTag] = useState<string>("");
    const [cc, setCC] = useState<string>("");
    const [error, setError] = useState('');

    useEffect(() => {
        if (open) {
            document.body.classList.add("overflow-hidden");
            setTag("");
            setCC("");
            setError("");
        } else {
            document.body.classList.remove("overflow-hidden");
        }

        return () => document.body.classList.remove("overflow-hidden");
    }, [open]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setCC(value);

        // Clear error as user types
        if (error) setError('');
    };

    const validateEmail = () => {
        if (cc?.trim() !== "" && !emailRegex.test(cc)) {
            setError('Please enter a valid email address');
        } else {
            setError('');
        }
    };


    const closeModal = () => setOpen(false);

    const handleQuoteSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (!error) {
            setOpen(false)
            setPleasWaitPopup(true)

            let additionalValue = await Promise.all(
                reservation?.additionalCategoryDto?.map(async (item: any) => {
                    return item?.additionalChargesDto;
                }) || []
            );
            additionalValue = additionalValue.flat();

            post_quote({
                quote: {
                    reservationType: "Reservations",
                    customerId: parseInt(customerId),
                    vehicleClassId: parseInt(vehicleClassId),
                    branchId: parseInt(branchId),
                    pickupLoationId: parseInt(pickupLocationId),
                    returenLoationId: parseInt(returnLocationId),
                    pickupDate: pickupDate + "T" + pickupTime,
                    returenDate: returnDate + "T" + returnTime,
                    securityDepositAmount: reservation?.securityDepositAmount,
                    hourlyRate: reservation?.hourlyRate || 0,
                    dailyRate: reservation?.dailyRate || 0,
                    weeklyRate: reservation?.weeklyRate || 0,
                    monthlyRate: reservation?.monthlyRate || 0,
                    commissionPartner: "",
                    clientPaysatCommissionPartner: false,
                    rackPrice: reservation?.totalBasePriceBeforeDiscount,
                    totalPrice: reservation?.totalPrices,
                    discount: 0,
                    status: quoteFormType === 1 ? "Create Pdf" : "Send Email",
                    tag,
                    locationFeeAmount: reservation?.locationFeeAmount ?? 0,
                    taxAmount: reservation?.taxAmount ?? 0,
                    mandatoryAdditionalChargesAmount: reservation?.mandatoryAdditionalChargesAmount ?? 0,
                    governmentTaxAmount: reservation?.governmentTaxAmount ?? 0,
                    locationFeePercentage: reservation?.locationFeePercentage ?? 0,
                    taxPercentage: reservation?.taxPercentage ?? 0,
                    governmentTaxPercentage: reservation?.governmentTaxPercentage ?? 0,
                    createdDate: new Date().toLocaleString(),
                    reservationId: 0
                },
                quoteAdditionalCharges: additionalValue?.map(item => (
                    {
                        additionalChargeByBranchId: item?.additionalChargeByBranchId,
                        quantity: item?.quantity,
                        basePrice: item?.basePrice
                    }
                )),
                quoteDiscounts: [],
                fileUploadDatas: []
            }, 0, tenantId)
                .then((data) => {
                    if (quoteFormType === 1) {
                        setPleasWaitPopup(false);
                        window.open(`/carrental/reservations/print-quote?id=${data?.id}`, "_blank", "noopener,noreferrer");
                    } else {
                        sendQuoteEmail(data?.id);
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                })
        }
    }

    const sendQuoteEmail = async (quoteId: number) => {
        await sendQuoteEmailAPI(quoteId, cc, tenantId)
            .then(() => {
                setPleasWaitPopup(false);
            })
            .catch((error) => {
                setPleasWaitPopup(false);
                console.error("Error:", error);
            });
    }

    if (!open) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="w-full max-w-lg mx-4 bg-white p-6 rounded-xl shadow-lg">
                {/* Close Icon */}
                <div className="flex justify-end">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320.591 320.591"
                        className="w-4 h-4 cursor-pointer fill-gray-600"
                        onClick={closeModal}
                    >
                        <path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" />
                        <path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" />
                    </svg>
                </div>

                <h4 className="font-semibold mb-4">{quoteFormType === 1 ? "Create Pdf of Quote" : "Send Quote to Email"}</h4>
                <form onSubmit={handleQuoteSubmit}>
                    <div className="flex flex-col md:flex-row md:space-x-4">
                        <div className="flex-1 mb-4 md:mb-0">
                            <label className="block text-sm font-medium mb-1">Customer</label>
                            <span className="text-sm text-gray-500 font-medium">{customerData?.firstName} {customerData?.lastName}</span>
                        </div>
                        <div className="flex-1">
                            <label className="block text-sm font-medium mb-1">Tags</label>
                            <input type="text" className="w-full text-sm text-gray-500 border border-gray-300 rounded-md px-3 py-2 focus:outline-none"
                                value={tag}
                                onChange={(e) => setTag(e.target.value)}
                            />
                        </div>
                    </div>
                    {
                        quoteFormType === 2 && (
                            <div className="mt-4">
                                <label className="block text-sm font-medium mb-1">Cc</label>
                                <input type="text" className="w-full text-sm text-gray-500 border border-gray-300 rounded-md px-3 py-2 focus:outline-none"
                                    value={cc}
                                    onChange={handleChange}
                                    onBlur={validateEmail}
                                />
                                {error && <span className="text-red-500 text-sm">{error}</span>}
                            </div>
                        )
                    }

                    <div className="mt-4">
                        <label className="block text-sm font-medium mb-1">Language</label>
                        <select className="w-full text-sm text-gray-500 border border-gray-300 rounded-md px-3 py-2 focus:outline-none">
                            <option>English</option>
                        </select>
                    </div>

                    {/* Buttons */}
                    <div className="flex gap-4 mt-6">
                        <button type="submit" className="text-white px-4 py-2 rounded cursor-pointer"
                            style={{
                                backgroundColor: webData?.websiteHeaderColor
                            }}
                        >
                            {quoteFormType === 1 ? "Create PDF" : "Send Quote"}
                        </button>

                        <button
                            onClick={closeModal}
                            className="px-4 py-2 rounded bg-gray-200 text-gray-800 hover:bg-gray-300 transition cursor-pointer"
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}